<div class="instructions-container">
  <p class="section-subtitle">Please provide the following delivery information (all fields required)</p>

  <form [formGroup]="deliveryInstructionsForm" class="delivery-instructions-form" (ngSubmit)="onSubmit()">
    <div class="delivery-question">
      <label class="question-label">
        1. What type of delivery location is this? <span class="required">*</span>
      </label>
      <div class="radio-group">
        @for (option of deliveryLocation; track option) {
          <div class="radio-option">
            <input type="radio" class="radio-input" [checked]="isChecked(option.value)"
              [id]="'deliveryLocation-' + option.value" [value]="option.value" formControlName="deliveryLocation" />
              <label class="radio-label" [for]="'deliveryLocation-' + option.value">{{ option.label }}</label>
            </div>
          }
        </div>
        <cx-form-errors [control]="deliveryInstructionsForm.get('deliveryLocation')"></cx-form-errors>
      </div>

      <div class="delivery-question">
        <label class="question-label">
          2. Contact name and mobile number for delivery
        </label>
        <div class="form-row">
          <div class="form-group" [ngClass]="{'has-error': isInvalid('firstName')}">
            <label class="form-label" for="contact-first-name">First Name <span class="required">*</span></label>
            <input type="text" id="contact-first-name" class="form-input" maxlength="50" formControlName="firstName"
              required>
              <cx-form-errors [control]="deliveryInstructionsForm.get('firstName')"></cx-form-errors>
            </div>
            <div class="form-group" [ngClass]="{'has-error': isInvalid('lastName')}">
              <label class="form-label" for="contact-last-name">Last Name <span class="required">*</span></label>
              <input type="text" id="contact-last-name" class="form-input" maxlength="50" formControlName="lastName"
                required>
                <cx-form-errors [control]="deliveryInstructionsForm.get('lastName')"></cx-form-errors>
              </div>
            </div>

            <div class="form-group full-width" [ngClass]="{'has-error': isInvalid('mobileNumber')}">
              <label for="mobileNumber">Mobile Number <span class="required">*</span></label>
              <input id="mobileNumber" class="form-input" formControlName="mobileNumber"
                (input)="formatPhoneNumber('mobileNumber')">
                <cx-form-errors [control]="deliveryInstructionsForm.get('mobileNumber')"></cx-form-errors>
              </div>

              <button type="button" class="add-contact-btn mb-3" id="add-contact-btn" (click)="enableDisableFormFields(true)">
                <span class="plus-icon">+</span>Add Additional Contact
              </button>

              @if (showAdditionaForm) {
                <div class="additional-contact-section">
                  <div class="additional-contact-header">
                    <span class="additional-contact-title">Additional Contact Details</span>
                    <button type="button" class="remove-contact-btn" id="remove-contact-btn"
                    (click)="enableDisableFormFields(false)">Remove</button>
                  </div>
                  <div class="form-row">
                    <div class="form-group">
                      <label class="form-label" for="additional-first-name">First Name</label>
                      <input type="text" id="additional-first-name" maxlength="50" class="form-input"
                        formControlName="additionalFirstName">
                      </div>
                      <div class="form-group">
                        <label class="form-label" for="additional-last-name">Last Name</label>
                        <input type="text" id="additional-last-name" maxlength="50" class="form-input"
                          formControlName="additionalLastName">
                        </div>
                      </div>
                      <div class="form-group full-width">
                        <label class="form-label" for="additional-phone">Mobile Number</label>
                        <input type="tel" id="additional-phone" maxlength="14" (input)="formatPhoneNumber('additionalMobileNumber')"
                          placeholder="(XXX)-XXX-XXXX" class="form-input" formControlName="additionalMobileNumber">
                        </div>
                      </div>
                    }
                  </div>

                  <div class="delivery-question">
                    <label class="question-label" [ngClass]="{'has-error': isInvalid('palletJack')}">
                      3. Do you need a pallet jack for delivery? <span class="required">*</span>
                    </label>
                    <div class="radio-group">
                      @for (option of yesNoOptions; track option) {
                        <div class="radio-option">
                          <input type="radio" class="radio-input" [id]="'palletJack-' + option.value" [value]="option.value"
                            formControlName="palletJack" />
                            <label class="radio-label" [for]="'palletJack-' + option.value">{{ option.label }}</label>
                          </div>
                        }
                      </div>
                      <cx-form-errors [control]="deliveryInstructionsForm.get('palletJack')"></cx-form-errors>
                      <div class="note-box">
                        <p class="note-text">
                          Select this option if your location does not have a forklift for offloading.
                        </p>
                      </div>
                    </div>

                    <div class="delivery-question">
                      <label class="question-label" [ngClass]="{'has-error': isInvalid('liftGate')}">
                        4. Do you need a lift gate for delivery? <span class="required">*</span>
                      </label>
                      <div class="radio-group">
                        @for (option of yesNoOptions; track option) {
                          <div class="radio-option">
                            <input type="radio" class="radio-input" [id]="'liftGate-' + option.value" [value]="option.value"
                              formControlName="liftGate" />
                              <label class="radio-label" [for]="'liftGate-' + option.value">{{ option.label }}</label>
                            </div>
                          }
                        </div>
                        <cx-form-errors [control]="deliveryInstructionsForm.get('liftGate')"></cx-form-errors>
                        <div class="note-box">
                          <p class="note-text">
                            Select this option if your location does not have a loading dock.
                          </p>
                        </div>
                      </div>

                      <div class="delivery-question">
                        <label class="question-label" [ngClass]="{'has-error': isInvalid('driverAssistance')}">
                          5. Is driver assistance required? <span class="required">*</span>
                        </label>
                        <div class="radio-group">
                          @for (option of yesNoOptions; track option) {
                            <div class="radio-option">
                              <input type="radio" class="radio-input" [id]="'driverAssistance-' + option.value" [value]="option.value"
                                formControlName="driverAssistance" />
                                <label class="radio-label" [for]="'driverAssistance-' + option.value">{{ option.label }}</label>
                              </div>
                            }
                          </div>
                          <cx-form-errors [control]="deliveryInstructionsForm.get('driverAssistance')"></cx-form-errors>
                          <div class="note-box">
                            <p class="note-text">
                              The driver will assist with offloading the product at your location.
                            </p>
                          </div>
                        </div>

                        <div class="delivery-question" [ngClass]="{'has-error': isInvalid('insideDelivery')}">
                          <label class="question-label" for="special-handling">
                            6. Any special handling requirements? <span class="required">*</span>
                          </label>
                          <textarea id="special-handling" class="textarea" formControlName="specialHandlingText"
                          placeholder="Please describe any special handling requirements..." required="" style="height: 79px;"></textarea>
                        </div>

                        <div class="delivery-question" [ngClass]="{'has-error': isInvalid('insideDelivery')}">
                          <label class="question-label">
                            7. Is inside delivery required? <span class="required">*</span>
                          </label>
                          <div class="radio-group">
                            @for (option of yesNoOptions; track option) {
                              <div class="radio-option">
                                <input type="radio" class="radio-input" [id]="'insideDelivery-' + option.value" [value]="option.value"
                                  formControlName="insideDelivery" />
                                  <label class="radio-label" [for]="'insideDelivery-' + option.value">{{ option.label }}</label>
                                </div>
                              }
                            </div>
                            <cx-form-errors [control]="deliveryInstructionsForm.get('insideDelivery')"></cx-form-errors>
                            <div class="note-box">
                              <p class="note-text">
                                Inside delivery means the driver will bring the product inside the building.
                              </p>
                            </div>
                          </div>

                          <div class="delivery-question">
                            <label class="question-label" [ngClass]="{'has-error': isInvalid('callAhead')}">
                              8. Is a call ahead required for delivery? <span class="required">*</span>
                            </label>
                            <div class="radio-group">
                              @for (option of yesNoOptions; track option) {
                                <div class="radio-option">
                                  <input type="radio" class="radio-input" [id]="'callAhead-' + option.value" [value]="option.value"
                                    formControlName="callAhead" />
                                    <label class="radio-label" [for]="'callAhead-' + option.value">{{ option.label }}</label>
                                  </div>
                                }
                              </div>
                              <cx-form-errors [control]="deliveryInstructionsForm.get('callAhead')"></cx-form-errors>
                            </div>

                            <div class="delivery-question" [ngClass]="{'has-error': isInvalid('deliveryAppointment')}">
                              <label class="question-label">
                                9. Is a delivery appointment required? <span class="required">*</span>
                              </label>
                              <div class="radio-group">
                                @for (option of yesNoOptions; track option) {
                                  <div class="radio-option">
                                    <input type="radio" class="radio-input" [id]="'deliveryAppointment-' + option.value" [value]="option.value"
                                      formControlName="deliveryAppointment" />
                                      <label class="radio-label" [for]="'deliveryAppointment-' + option.value">{{ option.label === 'Yes' ?
                                      option.label + ', schedule appointment' : option.label + ' Appointment needed' }}</label>
                                    </div>
                                  }
                                </div>
                                <cx-form-errors [control]="deliveryInstructionsForm.get('deliveryAppointment')"></cx-form-errors>

                                @if (showHideDeliveryAppt) {
                                  <div class="appointment-times" id="appointment-times"
                                    [ngClass]="{'has-error': isInvalid('appointmentTimeSlot')}">
                                    <label class="form-label mt-2" for="appointment-time-select">
                                      Select appointment time <span class="required">*</span>
                                    </label>
                                    <select formControlName="appointmentTimeSlot" class="form-control">
                                      <option value=null disabled>Please select a time slot</option>
                                      @for (timeSlot of timeSlots; track timeSlot; let i = $index) {
                                        <option [value]="timeSlot?.key">{{ timeSlot?.text }}
                                        </option>
                                      }
                                    </select>
                                  </div>
                                }
                                <cx-form-errors [control]="deliveryInstructionsForm.get('appointmentTimeSlot')"></cx-form-errors>
                              </div>

                              @if (this.showHideDeliveryAppt === false) {
                                <div class="delivery-question" id="delivery-hours-question">
                                  <label class="question-label" for="delivery-hours">
                                    10. If no delivery appointment is required, what are the delivery hours? <span class="required">*</span>
                                  </label>
                                  <div class="form-row">
                                    <div class="form-group" [ngClass]="{'has-error': isInvalid('deliveryHoursText')}">
                                      <input type="text" id="delivery-hours" class="form-input" maxlength="30"
                                        placeholder="e.g., 8 - 5, Monday - Friday" formControlName="deliveryHoursText" required>
                                        <cx-form-errors [control]="deliveryInstructionsForm.get('deliveryHoursText')"></cx-form-errors>
                                      </div>
                                      <div class="form-group" [ngClass]="{'has-error': isInvalid('deliveryHoursPeriod')}">
                                        <select id="delivery-hours-ampm" class="form-input" formControlName="deliveryHoursPeriod" required>
                                          <option value=null disabled>AM/PM</option>
                                          <option value="AM">AM</option>
                                          <option value="PM">PM</option>
                                        </select>
                                        <cx-form-errors [control]="deliveryInstructionsForm.get('deliveryHoursPeriod')"></cx-form-errors>
                                      </div>
                                    </div>
                                  </div>
                                }

                                <div class="d-flex justify-content-end">
                                  <button type="submit" class="continue-btn" [disabled]="!deliveryInstructionsForm.valid">Continue</button>
                                </div>
                              </form>
                            </div>